import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, FormGroup } from "reactstrap";
import axios from "axios";

const EditHeadsetModal = ({ isOpen, toggle, headset, onSaved }) => {
    const [name, setName] = useState("");
    const [pid, setPid] = useState("");
    const [model, setModel] = useState("");

    useEffect(() => {
        if (headset) {
            setName(headset.headset_NAME || "");
            setPid(headset.headset_PID || "");
            setModel(headset.headset_MODEL || "");
        }
    }, [headset]);

    const handleSave = async () => {
        try {
            await axios.put("/api/headset/update", {
                headset_id: headset.headset_id,
                headset_NAME: name,
                headset_PID: pid,
                headset_MODEL: model
            }, { withCredentials: true });

            onSaved();  // rafraîchir la liste des casques
            toggle();   // fermer la modal
        } catch (err) {
            console.error(err.response?.data || err);
        }
    };


    if (!headset) return null;

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Modifier le casque</ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label>Nom</Label>
                    <Input type="text" value={name} onChange={e => setName(e.target.value)} />
                </FormGroup>
                <FormGroup>
                    <Label>PID</Label>
                    <Input type="text" value={pid} onChange={e => setPid(e.target.value)} />
                </FormGroup>
                <FormGroup>
                    <Label>Modèle</Label>
                    <Input type="text" value={model} onChange={e => setModel(e.target.value)} />
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Annuler</Button>
                <Button color="primary" onClick={handleSave}>Enregistrer</Button>
            </ModalFooter>
        </Modal>
    );
};

export default EditHeadsetModal;

//Creators : Florian Cohen-Joly @3DDGAMES -- Under license
